export const POSTCODE_REGEX =
  '[A-Za-z]{1,2}[0-9]{1,2}[A-Za-z]{0,1} ?[0-9][A-Za-z]{2}';
export const REFERENCE_NUMBER_REGEX = /^([-\s]?[\d]{1}){12}$/;
export const RENEWAL_REGEX = /^([A-Za-z0-9\s]{10})$/;
